import Navbar from './components/navbar/navbar';

function App() {
  return (
    <div>
    <Navbar/>
    </div>
  );
}

export default App;
